import { createEntityAdapter, EntityState } from "@ngrx/entity"
import { WidgetConfiguration } from "../models/widget-configuration"
import * as widgetConfigActions from "../actions/widget-configs"
import { createFeatureSelector, createSelector } from "@ngrx/store"

export const widgetConfigAdapter = createEntityAdapter<WidgetConfiguration>();

export interface State extends EntityState<WidgetConfiguration> {
  loading: boolean;
  error: any;
}

export const initialState: State = widgetConfigAdapter.getInitialState({
  loading: false,
  error: undefined,
});

export function reducer(state: State = initialState, action: widgetConfigActions.Actions): State {
  switch (action.type) {
    case widgetConfigActions.LOAD_ALL:
    case widgetConfigActions.LOAD_BY_PROFILE:
    case widgetConfigActions.LOAD:
      {
        return widgetConfigAdapter.removeAll({ ...state, loading: true, error: undefined });
      }
    case widgetConfigActions.LOAD_COMPLETE:
      {
        return widgetConfigAdapter.addMany(action.payload, { ...state, loading: false, error: undefined });
      }
    case widgetConfigActions.LOAD_ERROR:
      {
        return { ...state, loading: false, error: action.payload };
      }
    default:
      {
        return state;
      }
  }
}

export const selectWidgetConfigState = createFeatureSelector<State>('widgetConfig');


export const {
  selectIds,
  selectEntities,
  selectAll: selectAllWidgetConfigs,
  selectTotal,
} = widgetConfigAdapter.getSelectors(selectWidgetConfigState);
